import { useEffect } from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { RaidLayout } from './RaidLayout'
import { Button } from '../Common'
import { usePushBackHandler } from '../../context/BackStackContext'
import styles from './Raid.module.css'

interface RaidOverlayProps {
  open: boolean
  onClose: () => void
}

/**
 * Full-viewport wrapper around RaidLayout for the Helper and Member apps,
 * which don't have a rail-page container of their own. Handles Esc dismiss and
 * body-scroll lock while the overlay is open.
 */
export const RaidOverlay = ({ open, onClose }: RaidOverlayProps) => {
  usePushBackHandler(onClose, open)

  useEffect(() => {
    if (!open) return undefined
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKey)
    return () => {
      document.body.style.overflow = originalOverflow
      window.removeEventListener('keydown', handleKey)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className={styles.overlay}
      // eslint-disable-next-line no-restricted-syntax -- full-screen raid overlay
      role="dialog"
      aria-modal="true"
      aria-label="Raid"
    >
      <div className={styles.overlayHeader}>
        <Button variant="tertiary" size="sm" className={styles.overlayCloseButton} icon={<CloseRoundedIcon fontSize="inherit" />} onClick={onClose}>
          Close
        </Button>
      </div>
      <RaidLayout />
    </div>
  )
}
